// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".banner-container {\n  color: #b83d3d;\n  padding: 15px;\n  border: 1px solid #f2cad1;\n  background-color: #fdd0cb;\n  border-radius: 2px;\n}\n\n.banner-container ul {\n  padding-left: 15px;\n  margin-bottom: 0px;\n}\n\n.banner-container .banner-header {\n  font-size: 15pt;\n  margin-bottom: 5px;\n}\n\n.banner-container .banner-header .banner-icon {\n  margin-right: 10px;\n}\n\n.nonurgent {\n  color: #d3871f;\n  border-color: #d3871f;\n  background-color: #fef8ef;\n}\n", ""]);
// Exports
module.exports = exports;
